import React, { useState } from 'react';
import axios from 'axios';
import { validate, format } from 'rut.js'
import ReactHtmlParser from 'react-html-parser'; 

const config = require('../../../configuration');

const Intro = ({setStateEstado, stateMetadata}) => {

    let params = new URLSearchParams(window.location.search);

    const [stateForm, setStateForm] = useState({
            rut : '',
            errorRut : true
        }
    )

    const [stateFormCC, setStateFormCC] = useState({
        rut : '',
        estadoRutCC : true
    }
)

    const inserInput = (e) => {
        const viene = e.target.name
        setStateForm({ 
            ...stateForm,
            [viene]:format(e.target.value),
            errorRut:true
        });

        setStateFormCC({
            ...stateFormCC,
            estadoRutCC : true,
            rut: ''
        });
    }

    const validar = async (e) =>{
        e.preventDefault();
        const rut = btoa(stateForm.rut);
        const sid = stateMetadata.sid;
        const tag = (params.get('tag') != null) ? params.get('tag') : sid  ;
        const errorRut = validate(stateForm.rut) && stateForm.rut.length > 6;
        setStateForm({
            ...stateForm,
            errorRut ,
            rut: ''
        });
                
        if(errorRut)
        {
            validarRutCC(stateForm.rut).then(estadoRutCC => {
                setStateFormCC({
                    ...stateFormCC,
                    estadoRutCC,
                    rut: ''
                });
                // Valido si el rut existe en CC
                if ( estadoRutCC ){
                    setStateEstado(true);
                    SenData(rut, sid, tag);
                } else {
                    setStateEstado(false);
                    return false;    
                }
            });

        }else{
            setStateEstado(false);
            return false;
        }
    }

    const validarRutCC = async (rut) => {
        return new Promise((resolve, reject) => {
            axios.get(`${config.URL_API_PANEL}/validar-rut-panel?user_rut=${rut}`)
            .then(response => {
                // Aquí puedes manejar la respuesta del servidor
                if ( parseInt(response.data?.status) == 200 ) {
                    // console.log('NO EXISTE:', response.data?.msg);
                    // setStateEstadoCC(true);
                    resolve(true);
                } else {
                    // console.log('EXISTE:', response.data?.msg);
                    // setStateEstadoCC(false);
                    resolve(false);
                }
            })
            .catch(error => {
                // Aquí puedes manejar los errores en caso de que ocurran
                console.error(error);
                // setStateEstadoCC(false);
                resolve(false);
            });
        });
    }

    const SenData = async (rut, sid, tag) => {

        let rut_clean =  atob(rut).split('.').join("");
        const { conector_id } = stateMetadata;
        
        //usuario existe en panel
        //usuario se inserta por primera vez en limesurvey || usuario ya estaba insertado anteriormente en limesurvey  
        axios.get(`${config.API_BASE_URL_ENCUESTAS_DESTACADAS}/service-verificar/rut/${btoa(rut_clean)}/sid/${sid}/conector_id/${conector_id}`).then(response => {
           let token = response.data.data.token;
           if(response.data.ok)
           {   
               if(token != null) {
                   window.location.href = `${config.URL_BASE_LIMESURVEY}/${sid}?token=${token}&newtest=Y`;
               }
           }
           //usuario no existe en panel
           if(response.data.data.rut != null)
           {
                window.location.href = `${config.URL_FORMULARIO_REGISTRO}?tag=${tag}&sid=${sid}&rut=${rut_clean}`;
           }
       });
    }

    return (
        <section id="intro" className="intro-section cover" style={{ backgroundImage: "url(" + stateMetadata.imagen_fondo + ")", }}>
		    <div className="overlay"></div>
		    <div className="container banner-intro">
                <div className="headline headline-big mb-30 text-center" style={{ display : 'flex', flexWrap : 'wrap' }}>
                    <div className="col-md-6">
                        <img src={stateMetadata.imagen_premio} alt="Premio" />
                    </div>
                    <div className="col-md-6">
                        <h2>{ ReactHtmlParser(stateMetadata.title)}</h2>
                            {/*<strong>¡Regístrate y gana premios</strong> contestando encuestas online!*/}
                        <div className="text-center">
                            { ReactHtmlParser(stateMetadata.subtitle)}
                        {/*<p>
                            <strong>Tu rut es solicitado para resguardar la duplicidad de identidad.<br />
                            Registrate en el sitio, contesta la encuesta y ya estarás participando.</strong>
                        </p>*/}
                        <form className="form leads-form" onSubmit={validar}>
                            <div className="input-group">
                                <input type="text" 
                                    name="rut"
                                    onChange={inserInput}
                                    className="form-control email-capture" 
                                    placeholder="ej: 16.589.458-6" 
                                    value={stateForm.rut}
                                    style={{ borderRadius : '4px'}}
                                />
                                <span className="input-group-btn">
                                <button className="btn btn-submit-form" type="submit">Participa aquí</button>
                                </span>
                            </div>
                        </form>
                        {!stateForm.errorRut ?
                            <div className="error-msg">
                                <div className="alert alert-danger" role="alert">
                                    <strong>El rut que ingresaste no es válido, por favor intenta nuevamente </strong>
                                </div>
                            </div> 
                        : null }

                        {!stateFormCC.estadoRutCC ?
                            <div className="error-msg">
                                <div className="alert alert-danger" role="alert">
                                    <strong>El rut que ingresaste no es válido, ya se encuentra registrado en Comunidad Cadem </strong>
                                </div>
                            </div> 
                        : null }
                    </div>
                    </div>
                </div>
            </div>
	</section>
    )
}

export default Intro;
